module.exports = __webpack_public_path__ + "img/share_defalut.015468cd.png";